import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import CalloutBox from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CalloutBox icon="IconInfo" title="Workflows is in beta" type="fyi" mdxType="CalloutBox">
      <p>{`Workflows is currently in early beta. While in beta, workflows is free to use. See the overview page for the `}<a parentName="p" {...{
          "href": "/docs/workflows#pricing"
        }}>{`proposed pricing model`}</a>{`.`}</p>
      <p>{`We're always looking for feedback to improve workflows, please `}<a parentName="p" {...{
          "href": "https://app.posthog.com/workflows#panel=support%3Afeedback%3A%3Alow%3Atrue"
        }}>{`reach out to us directly`}</a>{` in app. `}</p>
    </CalloutBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      